import type { IconSvgObject } from './types';

const ZodiacPiscesIcon: IconSvgObject = [
  ["path", { d: "M17.9999 3C16.1296 5.42035 14.9999 8.56402 14.9999 12C14.9999 15.436 16.1296 18.5797 17.9999 21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.99994 21C7.87026 18.5797 8.99994 15.436 8.99994 12C8.99994 8.56402 7.87026 5.42035 5.99994 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.9999 12L4.99994 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ZodiacPiscesIcon;
